export default __webpack_public_path__ + "static/media/Bracers of Insanity.5f503035.jpg";